import { Application } from "../context";

import * as util from "./Util";

export const BadgePrintingLogic = (acquirer: () => Promise<Response>, loading: boolean = true) => {
    if (loading) { Application.startLoading(); }
    const windowReference = window.open();

    return new Promise((resolve, reject) => {
        if (!windowReference) {
           reject(new Error("We couldn't open a new tab, please check your pop-up blocking settings and try again."));
           return;
        }

        windowReference.document.body.innerHTML = "<div style='text-align:center;font-family:sans-serif;'><h2>Please wait...</h2></div>";
        acquirer()
            .then(response => {
                response
                    .blob()
                    .then(blob => {
                        if (loading) { Application.doneLoading(); }
                        util.OpenBlobInNewWindow(blob, windowReference);
                        resolve(blob);
                    })
                    .catch(err => {
                        if (loading) { Application.doneLoading(); }
                        windowReference.close();
                        reject(err);
                    });
            })
            .catch(err => {
                if (loading) { Application.doneLoading(); }
                windowReference.close();
                reject(err);
            });
    });
};
